const LOADER_PLACES = {
    REMOVAL: 'REMOVAL',
    CONFIRMATION: 'CONFIRMATION',
}

export default LOADER_PLACES;
